import { Stack } from "@mui/material";
import { memo, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clsx } from "clsx";
import { stepsPaths } from "../../../constants";
import { StepPathType } from "../../../shared";
import styles from "./Step.module.scss";
import { useCurrentSearchParam } from "../../../utils/hooks/useCurrentSearchParam";
import {DoubleRightArrow} from "../../SVGasComponent";

type OwnProps = {
    label: string;
    path: StepPathType;
    stepIndex: number;
};
export const Step = memo(({ label, path, stepIndex }: OwnProps) => {
    const navigate = useNavigate();
    const location = useLocation();
    const current = location.pathname.split("/")[1];
    const currentIndex = useMemo(() => stepsPaths.indexOf(current as StepPathType), [current]);
    const [, , hashForUrl] = useCurrentSearchParam('hash')

    const onClickHandle = () => {
        current !== path && navigate(path + hashForUrl);
    };

    const flashMenu = location.pathname.includes(path);

    return (
        <Stack
            direction={"row"} alignItems="center" justifyContent='center'
            style={{ boxSizing: 'content-box' }}
            component={"div"}
            zIndex={stepsPaths.length - stepIndex}
            className={clsx(styles.main,
                flashMenu && styles.active,
                stepIndex === 0 && styles.first,
                stepIndex === stepsPaths.length - 1 && styles.last,
                currentIndex === stepIndex - 1 && styles.next,
                currentIndex > stepIndex && styles.passed,
            )}
            onClick={onClickHandle}
        >
            <Stack direction={"row"} alignItems="center" justifyContent='center'>
                <span className={clsx(styles.text)}>{label}</span>
                <DoubleRightArrow color={flashMenu ? '#EB3D00' : '#FFF'} />
            </Stack >

        </Stack >
    );
});
